import { createFileRoute } from '@tanstack/react-router';

import ComingSoonCover from '@/components/ComingSoonCover';

function SettingsRoute() {
  return <ComingSoonCover />;
}

export const Route = createFileRoute('/_staff/payroll/_layout/settings/')({
  component: SettingsRoute,
});
